<template>
  <v-container fluid>
    <v-row wrap align-center>
      <v-col cols=12>
        <div class="text-center">
          <h1 class="headline font-weight-medium">
            {{ $vuetify.lang.t(`$vuetify.landing.diplomas.title`) }}
          </h1>
        </div>
        <v-divider class="my-3"></v-divider>
      </v-col>
    </v-row>

    <v-row wrap align-content-center align-center justify="center">
      <v-col v-for="(item, index) in vertical.images" :key="item" md="4" cols="12">
        <v-card class="mx-auto" max-width="400" elevation="10" @click="showVertical(index)">
          <v-img class="mx-auto" max-width="400" :src="item"></v-img>
        </v-card>
      </v-col>
    </v-row>

    <v-row wrap align-content-center align-center justify="center">
      <v-col v-for="(item, index) in horizontal.images" :key="item" md="4" cols="12">
        <v-card class="mx-auto" max-width="400" elevation="10" @click="showHorizontal(index)">
          <v-img class="mx-auto" max-width="400" :src="item"></v-img>
        </v-card>
      </v-col>
    </v-row>

    <div id="verticalRow">
      <viewer :images="vertical.images"
              @inited="verticalInitialized" v-show="false">
        <template slot-scope="scope">
          <img v-for="src in scope.images" :src="src" :key="src" alt="diploma">
        </template>
      </viewer>
    </div>

    <div id="horizontalRow">
      <viewer :images="horizontal.images"
              @inited="horizontalInitialized" v-show="false">
        <template slot-scope="scope">
          <img v-for="src in scope.images" :src="src" :key="src" alt="diploma">
        </template>
      </viewer>
    </div>
  </v-container>
</template>

<script>
import metaMixin from '../../mixins/metaMixin'

import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer/src/component.vue'

export default {
  name: 'diplomaSlide',
  mixins: [metaMixin],
  components: {
    Viewer
  },
  data: () => ({

    vertical: {
      viewer: null,
      images: [
        require('@/assets/landing/diplomas/science_committee.jpg'),
        require('@/assets/landing/diplomas/science_leaders.jpg'),
        require('@/assets/landing/diplomas/SofF.jpg')
      ],
      options: {
        container: '#verticalRow',
        fullscreen: false,
        loop: true,
        rotatable: false
      }
    },

    horizontal: {
      viewer: null,
      images: [
        require('@/assets/landing/diplomas/fruct21_demo.jpg'),
        require('@/assets/landing/diplomas/fruct23_demo.jpg'),
        require('@/assets/landing/diplomas/fruct24_demo.jpg'),
        require('@/assets/landing/diplomas/fruct25_demo.jpg'),
        require('@/assets/landing/diplomas/fruct25_demo2.jpg')
      ],
      options: {
        container: '#horizontalRow',
        fullscreen: false,
        loop: true,
        rotatable: false
      }
    }

  }),
  methods: {
    verticalInitialized (viewer) {
      this.$nextTick(() => {
        viewer.body = document.querySelector(this.vertical.options.container)
        this.vertical.viewer = viewer
      })
    },
    showVertical (index) {
      if (this.vertical.viewer) {
        this.vertical.viewer.view(index)
      }
    },
    horizontalInitialized (viewer) {
      this.$nextTick(() => {
        viewer.body = document.querySelector(this.horizontal.options.container)
        this.horizontal.viewer = viewer
      })
    },
    showHorizontal (index) {
      if (this.horizontal.viewer) {
        this.horizontal.viewer.view(index)
      }
    }
  },
  metaInfo: {
    title: 'Drive Safely | Diplomas',
    meta: [
      { name: 'description', content: 'Diplomas of the Drive Safely project' },
      { property: 'og:title', content: 'Drive Safely diplomas' },
      { property: 'og:site_name', content: 'Drive Safely' },
      { property: 'og:description', content: 'Diplomas of the Drive Safely project' },
      { property: 'og:url', content: 'https://mobiledrivesafely.com/diplomas' }
    ]
  }
}
</script>

<style scoped>

</style>
